import clsx from "clsx"
import { useTheme } from "next-themes"
import Image from "next/image"
import type { ChainIcon } from "../../constants/blockchains"

export function NetworkIcon({
  chainIcon,
  className,
  sizeClassName = "size-10",
}: {
  chainIcon: ChainIcon
  className?: string
  sizeClassName?: string
}) {
  const { resolvedTheme } = useTheme()
  const iconSrc = resolvedTheme === "dark" ? chainIcon.dark : chainIcon.light

  return (
    <div
      className={clsx(
        "-outline-offset-1 relative flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-100 outline-1 outline-gray-900/10 dark:bg-gray-700 dark:outline-white/10",
        className,
        sizeClassName
      )}
    >
      <Image
        src={iconSrc}
        alt=""
        className="-outline-offset-1 relative size-full rounded-full outline-1 outline-gray-900/10 dark:outline-white/10"
        width={40}
        height={40}
      />
    </div>
  )
}
